import * as React from 'react';
import pluralize from 'pluralize';
import { FilterDropdown, FilterInput } from 'components/tailwind-ui/FilterDropdown';
import { Customer } from 'types/Customer';
import { References } from './References';
import { Selection } from './types';

interface Props {
  references?: Customer[];
  isFetching: boolean;
  selection: Selection;
  setSelection: (customers: Selection) => void;
  search: string;
  setSearch: (search: string) => void;
}

export const ReferenceFilter: React.FC<Props> = (props) => {
  const { references, isFetching, selection, setSelection, search, setSearch } = props;

  const handleClearFilter = () => {
    setSelection([]);
  };

  const { filteredReferences, delta } = React.useMemo(() => {
    if (!references) {
      return { filteredReferences: undefined, delta: 0 };
    }
    const filtered = references.filter((c) => c.count > 0);
    const difference = references.length - filtered.length;
    return { filteredReferences: filtered, delta: difference };
  }, [references]);

  return (
    <FilterDropdown
      label="Reference ID"
      count={selection.length}
      clear={handleClearFilter}
      className="max-w-[300px]"
    >
      <FilterInput
        value={search}
        setValue={setSearch}
        fetching={isFetching}
        placeholder="Filter by reference ID"
      />
      <References
        references={filteredReferences}
        displayNoneOption={!search}
        selected={selection}
        setSelected={setSelection}
      />
      {references && delta !== 0 && (
        <div className="px-3 py-2">
          <h5>
            {delta} {pluralize('reference', delta)} not shown due to not being assigned to any
            containers.
          </h5>
        </div>
      )}
    </FilterDropdown>
  );
};
ReferenceFilter.displayName = 'Shipments.Components.ReferenceFilter';
